import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import can from 'ember-can/helpers/can';
import { LayoutSidebarSubnav } from 'core/components';

<template>
  {{pageTitle (t "page-title.projects.settings")}}

  <LayoutSidebarSubnav data-test-project-settings-nav as |Subnav|>
    <Subnav.BackLink
      @text={{t "components.page.projects.settings.nav.overview"}}
      @route="cloud.orgs.detail.projects.detail.index"
      data-test-project-settings-nav-back
    />

    <Subnav.Title data-test-project-settings-nav-title>
      {{t "components.page.projects.settings.nav.settings"}}
    </Subnav.Title>

    <Subnav.Link
      @icon="settings"
      @text={{t "components.page.projects.settings.nav.general"}}
      @route="cloud.orgs.detail.projects.detail.settings.general"
      data-test-project-settings-nav-general
    />

    {{#if (can "list webhook-webhooks")}}
      <Subnav.Link
        @icon="webhook"
        @text={{t "components.page.projects.settings.nav.webhooks"}}
        @route="cloud.orgs.detail.projects.detail.settings.webhooks"
        data-test-project-settings-nav-webhooks
      />
    {{/if}}
  </LayoutSidebarSubnav>

  {{outlet}}
</template>
